import { Box } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { MyMButton } from '../ui-elements/MyMButton';
import { MyMTreeCheckbox } from '../ui-elements/MyMTreeCheckbox';

export const ValidatableTreeCheckbox = (props) => {
  const {
    controllerName,
    treeItemList,
    checkedList,
    setChecked,
    control,
    rules,
    formState,
    trigger,
    clearText,
    width,
    height,
    needsCascade,
    handleValid = true
  } = props;

  useEffect(() => {
    if (formState.isSubmitted && trigger) {
      trigger(controllerName);
    }
    if (!handleValid && trigger) {
      trigger(controllerName);
    }
  }, [checkedList])

  return (
    <>
      <FormControl error={formState.errors[controllerName] ? true : false} sx={{width: "100%"} } >
        <Box sx={{
          border: formState.errors[controllerName] ? 'solid 1px rgba(211, 47, 47)' : 'solid 1px rgba(224, 224, 224, 1)',
          width: { width },
          height: { height },
          overflowY: "auto"
        }} >
          <Stack direction='row' spacing={1} sx={{ padding: '2px', margin: 1, }} >
            <MyMButton className='ms-auto'
              onClick={() => setChecked([])}>{clearText}
            </MyMButton>
          </Stack>
          <Controller
            control={control}
            name={controllerName}
            defaultValue=''
            render={() => (
              <MyMTreeCheckbox
                treeItemList={treeItemList}
                checkedList={checkedList}
                setCheckedList={setChecked}
                name={controllerName}
                needsCascade={needsCascade}
              />
            )}
            rules={rules}
          />
        </Box>
        <FormHelperText>{formState.errors[controllerName]?.message}</FormHelperText>
      </FormControl>
    </>
  );
}
